import React, {useState} from 'react';
import Papa from 'papaparse';
import FilePickerDialog from 'components/forms/FilePickerDialog';
import {Button} from 'components/forms/Buttons';
import {RecordType, SingleRecord} from 'components/record/RecordContext';
import CreateDialogBody from 'components/forms/CreateDialogBody';
import {useResourceContext} from 'components/record/ResourceContext';
import {FilePickerProps} from 'components/common/FilePicker';
import ImportList from 'components/forms/ImportList';
import {ListContextProvider, useListContext} from 'components/list/ListContext';
import {ColorField, ListField} from 'components/list/Fields';

const ImportCompetitors = (props: ImportCompetitorsProps) => {
  const {resource} = useResourceContext();
  const {refetch} = useListContext();

  const {callback = refetch, label = `Import ${resource}`, accept = '.csv', extension = 'csv', dialogTitle = 'Import', ...rest} = props;

  const [list, setList] = useState<RecordType[]>([]);

  const handleFileChange = (result: string) => {
    const data = Papa.parse(result, {header: true, dynamicTyping: true}).data as SingleRecord[];
    setList(data.map((item: SingleRecord) => ({...item, id: item.deviceId})));
  };

  return (
    <FilePickerDialog
      label={label}
      accept={accept}
      extension={extension}
      dialogTitle={dialogTitle}
      {...rest}
      handleFileChange={handleFileChange}
      fullWidth={false}
      primaryButton={
        <Button type="submit" form="create_Competitor" variant="contained">
          Create
        </Button>
      }
    >
      <CreateDialogBody onSuccess={callback} many>
        <ListContextProvider data={{list, total: list.length}}>
          <ImportList title="Competitors" payloadList="competitors">
            <ListField source="name" label="Name" />
            <ListField source="shortName" label="Short Name" />
            <ColorField source="color" label="Color" />
          </ImportList>
        </ListContextProvider>
      </CreateDialogBody>
    </FilePickerDialog>
  );
};

type ImportCompetitorsProps = Omit<FilePickerProps, 'onClick'> & {
  label?: string;
  extension?: string;
  dialogTitle?: string;
  callback?: () => void;
  handleFileChange?: (result: string) => void;
  defaultValues?: SingleRecord;
};

export default ImportCompetitors;
